import { render, staticRenderFns } from "./TwoTexts.vue?vue&type=template&id=31219eb3&scoped=true&lang=pug&"
import script from "./TwoTexts.vue?vue&type=script&lang=js&"
export * from "./TwoTexts.vue?vue&type=script&lang=js&"
import style0 from "./TwoTexts.vue?vue&type=style&index=0&id=31219eb3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31219eb3",
  null
  
)

export default component.exports